<div class="container-fluid placeeditor">
    <div class="row">
        <div class="main-container">
            <form class="form" id="ngForm" #f="ngForm" (ngSubmit)="f.form.valid && savePlace()">
                <!-- place show as -->
                <span>
                    <div class="placeshow">{{"lbl_place_show" | translate}}   <span class="place_belongs">{{selectedPlace.fullAddress}}</span></div>
                </span>

                <div class="place_data"></div>
                <div class="form-row basic-info-row">
                    <div class="form-group image-frame">
                        <!-- image -->
                        <div class="image-container">
                            <img class="btn-card element-over-hand" (click)="showDropDown()"
                                src="assets/multimedia-module/edit.png">

                            <!-- media place image  -->
                            <div *ngIf="selectedPlace.mediaType === 1">
                                <img class="image" [src]="[selectedPlace.mediaUrl]">
                            </div>

                            <!-- default image -->
                            <div class="non_place-short" *ngIf="selectedPlace.mediaType !== 1">
                                <img class="non_image_place" src="assets/place/Place_default.png">
                            </div>

                            <div>
                                <!-- dropdown in image -->
                                <div *ngIf="isDropDownOpen" class="content-box">
                                    <div class="element-over-hand" [ngClass]="[selectedPlace.detail ||selectedPlace.line2 || selectedPlace.line3 || selectedPlace.line4 || selectedPlace.line5 || selectedPlace.country? 'menu-item':'menu-item-disable']" ><span class="fa fa-picture-o"></span><span
                                            class="list-edit" (click)="selectedPlace.detail ||selectedPlace.line2 || selectedPlace.line3 || selectedPlace.line4 || selectedPlace.line5 || selectedPlace.country ? uploadPlaceImage():null" >
                                            {{"lbl_upload" | translate}}</span>
                                    </div>
                                    <div  [ngClass]="[selectedPlace.imageId > 0 ? 'menu-item':'menu-item-disable']" 
                                         class="element-over-hand"><span
                                            class="fa fa-trash-o"></span><span class="list-delete"
                                            (click)="selectedPlace.imageId > 0 ? removePlaceImage():null"> {{"lbl_unlink" | translate}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- form row 1 -->
                    <div class="form-group" class="name-fields-type">
                        <div class="form-row">
                            <div class="form-group placetype">
                                <label for="placetype">{{"lbl_place_type" | translate}}</label>
                                <select [(ngModel)]="selectedPlaceType" [ngModelOptions]="{standalone: true}"
                                    class="form-control placetypedropdown" (change)="selectPlaceType()">
                                    <option *ngFor="let place of dropdownList" [ngValue]="place">
                                        {{place.description  | translate}}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group placefarm">
                                <label for="inputPatroName">{{selectedPlaceType.fields.place | translate}}</label>
                                <input type="text" class="form-control" id="inputPatroName"
                                    [required]="(selectedPlace.line2 || selectedPlace.line3 || selectedPlace.line4 || selectedPlace.line5 || selectedPlace.country) ? false : true"
                                    [(ngModel)]="selectedPlace.detail" #detail="ngModel" name="detail">
                                <div *ngIf="f.submitted && detail.invalid" class="form-control-feedback">
                                    <div *ngIf="detail.errors.required ">
                                        <p class="validation-message">
                                            {{"val_place_validation_message" | translate}}</p>
                                    </div>
                                </div>
                                <div *ngIf="showValidation && !f.submitted">
                                    <p class="validation-message">
                                        {{"val_place_validation_message" | translate}}</p>
                                </div>


                            </div>
                            <div class="form-group placefarm">
                                <label for="inputLastName">{{ selectedPlaceType.fields.farm | translate}}</label>
                                <input type="text" class="form-control" id="inputLastName"
                                    [(ngModel)]="selectedPlace.line2" #line2="ngModel" name="line2" />
                            </div>

                        </div>
                    </div>
                </div>
                <!-- form row 2 -->
                <div class="form-row basic-info-row">
                    <div class="form-group name-fields-village">
                        <div class="form-row">
                            <div class="form-group villagemunicipality">
                                <label for="inputPatroName">{{selectedPlaceType.fields.village | translate}}</label>
                                <input type="text" class="form-control" id="inputPatroName"
                                    [(ngModel)]="selectedPlace.line3" #line3="ngModel" name="line3" />
                            </div>
                            <div class="form-group villagemunicipality">
                                <label for="inputLastName">{{selectedPlaceType.fields.municipility | translate}}</label>
                                <input type="text" class="form-control" id="inputLastName"
                                    [(ngModel)]="selectedPlace.line4" name="line4" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group villagemunicipality">
                                <label for="inputPatroName">{{selectedPlaceType.fields.county | translate}}</label>
                                <input type="text" class="form-control" id="inputPatroName"
                                    [(ngModel)]="selectedPlace.line5" name="line5" />
                            </div>
                            <div class="form-group villagemunicipality">
                                <label for="inputLastName">{{selectedPlaceType.fields.country | translate}}</label>
                                <input type="text" class="form-control" id="inputLastName"
                                    [(ngModel)]="selectedPlace.country" name="country" />
                            </div>
                            <div class="form-group placetype">
                                <label for="inputLastName">{{"lbl_note" | translate}}</label>
                                <input type="text" class="form-control" id="inputLastName"
                                    [(ngModel)]="selectedPlace.note" name="note" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="events">
                <div class="event_message">
                <label for="event-field">{{"lbl_event_message" | translate}}</label>
            </div>
            </div>
        </div>
    </div>
</div>
<div class="footer">
    <div class="buttons">
        <button type="submit" class="btn btn-active btn-foot element-over-hand" form="ngForm">
            {{"lbl_save" | translate}}
        </button>

        <span><button type="button" (click)="canclePopup()"
                class="btn btn-primary btn-foot btn-cancel element-over-hand">{{"lbl_cancel" | translate }}</button></span>
    </div>
</div>